import { autorun } from 'mobx';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useStore } from '@feathr/extender/state';

interface IUsePageTitleProps {
  pageTitle?: string;
  title?: ReactNode;
}

function usePageTitle({ pageTitle, title }: IUsePageTitleProps): void {
  const { eventId } = useParams<{ eventId: string }>();
  const { Events } = useStore();
  const titleString = pageTitle || (title && typeof title === 'string' ? title : '');

  useEffect(
    () =>
      autorun(() => {
        const titleSuffix = eventId ? Events.get(eventId)?.name : 'Feathr';
        // Bail early if event name is undefined - autorun will rerun once the name resolves
        if (titleSuffix === undefined) {
          return;
        }
        document.title = titleString ? `${titleString} | ${titleSuffix}` : titleSuffix;
      }),
    [eventId, titleString],
  );
}

export default usePageTitle;
